import React, { useContext } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { responseHandler } from '../components/utility/Utility';
import '../assets/css/views/support.css';
import { AuthContext } from '../contexts/AuthContext';


const SupportForm = () => {
    const { getJwtToken, handleSignOut } = useContext(AuthContext);

    const initialValues = {
        requestType: 'help',
        message: '',
    };

    const validationSchema = Yup.object({
        requestType: Yup.string().required('Please select a request type.'),
        message: Yup.string().required('Message cannot be empty.').min(10, 'Message must be at least 10 characters long.'),
    });

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        try {
            const token = await getJwtToken();
            const res = await axios.post(`https://api.amplifyloyalty.com/app/support`, values, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            responseHandler(res, "success", "Your request has been sent! We'll get back to you shortly.");
            resetForm();
        } catch (err) {
            responseHandler(err, "error");
            if (err.response && err.response.status === 401) {
                handleSignOut();
            }
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {({ isSubmitting }) => (
                    <Form className="support-form">
                        <div className="support-form__field">
                            <label htmlFor="requestType">What can we help you with?</label>
                            <Field as="select" name="requestType" className="support-form__input">
                                <option value="help">Get Help</option>
                                <option value="bug">Report a Bug</option>
                                <option value="feature">Request a Feature</option>
                                <option value="demo">Other</option>
                            </Field>
                            <ErrorMessage name="requestType" component="div" className="support-form__error" />
                        </div>

                        <div className="support-form__field">
                            <label htmlFor="message">Message</label>
                            <Field as="textarea" name="message" className="support-form__textarea" rows="8" />
                            <ErrorMessage name="message" component="div" className="support-form__error" />
                        </div>

                        <div className="support-form__button-container">
                            <button type="submit" className="support-form__submit-button btn" disabled={isSubmitting} style={{backgroundColor: "#000", color: "#fff"}}>
                                {isSubmitting ? 'Sending...' : 'Send Request'}
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
        </>
        
    );
};


export default function Support() {
    return (
        <div className="main">
            <div className="support-container">
                <div className="support-header">
                    <h2 className="support-heading">Support Center</h2>
                    <a 
                        href="https://calendly.com/trevor-amplifyloyalty/30min" 
                        target="_blank" 
                        className="gradient btn" 
                        style={{display: "block", margin: "20px auto", width: "fit-content"}}
                        onClick={() => {
                            if (window.fbq) {
                                window.fbq('track', 'Schedule');
                            }
                        }}
                    >
                        Schedule a Demo
                    </a>
                    <p className="support-subheading">We're here to help. Let us know what you need.</p>
                </div>
                <SupportForm />
            </div>
        </div>
    );
} 